// components/Toast.js
import React, { useEffect } from 'react';
import '../css/ChatToast.css';

const ChatToast = ({ type = 'success', message, duration = 3000, onClose }) => {
    useEffect(() => {
        const timer = setTimeout(() => {
            onClose?.();
        }, duration);
        return () => clearTimeout(timer);
    }, [duration, onClose]);

    return (
        <div className={`toast-container ${type === 'error' ? 'toast-error' : 'toast-success'}`}>
            {message}
        </div>
    );
};

export default ChatToast;
